import React from 'react';

export function StatTile({ label, value, unit, testId }) {
  return (
    <div className="glass-panel rounded-xl px-3 py-2.5" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-semibold">{label}</div>
      <div className="mt-1 flex items-baseline gap-1">
        <span className="font-mono-stat text-xl font-bold text-white leading-none">{value}</span>
        {unit && <span className="text-[11px] text-zinc-400">{unit}</span>}
      </div>
    </div>
  );
}
